import { Grid } from "@material-ui/core";
import React from "react";
import InvalidateCacheContainer from "./InvalidateCacheContainer";
import TranslationsContainer from "./TranslationsContainer";

const SettingsContainer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <InvalidateCacheContainer />
      </Grid>
      <Grid item xs={12}>
        <TranslationsContainer />
      </Grid>
    </Grid>
  );
};

export default SettingsContainer;
